export const ICON_TYPES = {
  CIRCLE: "circle",
  FILLED: "filled",
  OUTLINE: "outline",
};

export const ICON_SIZES = {
  DEFAULT: "IconMedium",
  LARGE: "IconLarge",
  MEDIUM: "IconMedium",
  SMALL: "IconSmall",
};
